/**
 * Texto preparado para buscar.
 *
 * Quita los acentos y la eñe antes de comparar, porque nadie los escribe al
 * buscar: se teclea "diseno" para encontrar "Sistema de diseño" y "almacen"
 * para encontrar "Almacén". Sin esto, la unica forma de dar con una seccion
 * seria escribir su nombre con la ortografia exacta, y en un teclado de
 * almacen eso no ocurre nunca.
 *
 * Funciona en los dos sentidos -lo escrito y lo buscado pasan por aqui- asi
 * que tambien encuentra "diseño" escrito con ñ dentro de un texto sin ella.
 *
 * `NFD` separa cada letra de su acento y el rango `̀-ͯ` borra los
 * acentos sueltos que quedan; la ñ se descompone en n + tilde, de modo que
 * cae por el mismo camino sin necesitar un caso aparte.
 */
export function paraBuscar(texto: string): string {
  return texto.normalize('NFD').replace(/[̀-ͯ]/gu, '').toLowerCase().trim();
}
